import { render, staticRenderFns } from "./setup-payouts.vue?vue&type=template&id=6a65ba23&"
import script from "./setup-payouts.vue?vue&type=script&lang=js&"
export * from "./setup-payouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports